<template>
   <v-container>
    <v-layout wrap>
        <v-flex md6>
         <v-layout wrap justify-center>
          <v-flex xs12 text-center>
            <span class="main">Observations</span>
          </v-flex>
          <v-flex v-if="observe.length > 0" xs12 pt-2>
            <apexchart
              width="100%"
              height="1000px"
              type="bar"
              :options="chartOptions1"
              :series="series"
            ></apexchart>
          </v-flex>
        </v-layout>
        </v-flex>
        <v-flex md6>
       <v-layout wrap>
           <v-flex xs12 text-center>
            <span class="main">Rescues</span>
          </v-flex>
          <v-flex v-if="res.length > 0" xs12 pt-2>
            <apexchart
              width="100%"
              height="1000px"
              type="bar"
              :options="chartOptions2"
              :series="rescue"
            ></apexchart>
          </v-flex>
       </v-layout>
        </v-flex>
    </v-layout>
    </v-container>

</template>
<script>
 import axios from "axios";
export default {
    data(){
        return{
             observe: [],
              series: [
        {
          name: "",
          data: [],
        },
      ],
      rescue: [
        {
          name: "",
          data: [],
        },
      ],
          chartOptions1: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
      }, 
         chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
      },   
            
        }
    },
    mounted(){
        this.getData();
    },
    methods:
    {
        getData(){
            axios({
                method:"GET",
                url:"/dashboard/stats"

            })
            .then((response) =>{
                if(response.data.status)
                {
                     this.observe = response.data.data.topobservationregions;
            for (var k = 0; k < this.observe.length; k++) {
              this.chartOptions1.xaxis.categories.push(this.observe[k].state);
              this.series[0].data.push(this.observe[k].count);
            }
            this.res = response.data.data.toprescueregions;
            for (var j = 0; j < this.res.length; j++) {
              this.chartOptions2.xaxis.categories.push(this.res[j].state);
              this.rescue[0].data.push(this.res[j].count);
            }
                }

            })
            .catch({

            })
        }
    }


}
</script>